export * from './src/galaxy-wrap.module';
export { GalaxyWrapComponent } from './src/galaxy-wrap.component';
